// extracted by mini-css-extract-plugin
export default {"cardContainer":"JlwikO6W3ElCMt2HZAb4-PopularArticles-cardContainer","smallCardContainer":"uK7T6XFoL5Lnvp4MO3e7-PopularArticles-smallCardContainer"};